import { inject, Injectable } from '@angular/core';
import { HttpClient }         from '@angular/common/http';
import { environment }        from '../../environments/environment';
import { catchError, map }    from 'rxjs/operators';
import { Observable, of }     from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private http = inject(HttpClient);


  init(): Observable<Record<string, unknown>> {
    return this.http.get('environment.json').pipe(
      map(data => {
        Object.assign(environment, data);
        return environment;
      }),
      catchError(() => of(environment))
    );
  }

}
